import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IOtherUserFeed } from "../../helpers/types";
import { getOtherUserFeedsById, getUserFeeds } from "../../redux/feeds/feedsSlice";
import { AppDispatch, StoreState } from "../../redux/store";

const useFetchFeeds = (id: string | null, isCurrentUser: boolean) => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentFeeds, otherUserFeeds, loading, error, currentFeedsPage, otherFeedsPage } = useSelector((state: StoreState) => state.feeds);
  const [feeds, setFeeds] = useState<IOtherUserFeed | null>(null);

  const fetchOtherUserFeeds = useCallback(
    (creatorId: string) => {
      if (otherUserFeeds.length === 0) {
        dispatch(getOtherUserFeedsById({ creatorId, page: otherFeedsPage }));
      } else {
        const feeds = otherUserFeeds.find((user: IOtherUserFeed) => user.id === id);
        if (feeds) {
          setFeeds(feeds);
        } else {
          dispatch(getOtherUserFeedsById({ creatorId, page: otherFeedsPage }));
        }
      }
    },
    [dispatch, otherUserFeeds, id]
  );

  const fetchCurrentUserFeeds = useCallback(() => {
    currentFeeds ? setFeeds(currentFeeds) : dispatch(getUserFeeds(currentFeedsPage));
  }, [dispatch, currentFeeds]);

  useEffect(() => {
    if (!isCurrentUser && id) {
      fetchOtherUserFeeds(id);
    }
    if (isCurrentUser) {
      fetchCurrentUserFeeds();
    }
  }, [id, isCurrentUser, fetchOtherUserFeeds, fetchCurrentUserFeeds]);

  return { loading, error, feeds };
};

export default useFetchFeeds;
